module.exports = __webpack_public_path__ + "static/media/drag-and-drop.cfa15771.png";